export enum ProjectType {
  NEW = 'NEW_FABRICATION',
  REGU = 'REGULARIZATION',
  OTHER = 'OTHERS'
}
